import { render, staticRenderFns } from "./businessonebox-alloutboxsystem.vue?vue&type=template&id=ba71beec&"
import script from "./businessonebox-alloutboxsystem.vue?vue&type=script&lang=js&"
export * from "./businessonebox-alloutboxsystem.vue?vue&type=script&lang=js&"
import style0 from "./businessonebox-alloutboxsystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports